import React, { useEffect, useRef } from 'react';

const Frame = ({ srcDoc }: { srcDoc: string }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const handleLoad = () => {
      const contentWindow = iframe.contentWindow;
      if (!contentWindow) {
        console.error('Iframe contentWindow is not available. This may be due to cross-origin restrictions.');
        return;
      }

      const doc = contentWindow.document;
      if (!doc) {
        console.error('Iframe document is not available.');
        return;
      }

      if (!doc.querySelector('link[href*="quill.snow.css"]')) {
        const link = doc.createElement('link');
        /**
         * https://unpkg.com is a popular CDN that serves files from npm packages
         * Make sure to use the css path of the react-quill
         * (@pending-forks/react-quill@2.0.1/dist/quill.snow.css)
         */
        link.href = 'https://unpkg.com/@pending-forks/react-quill@2.0.1/dist/quill.snow.css';
        link.type = 'text/css';
        link.rel = 'stylesheet';
        doc.head?.appendChild(link);
      }
    };

    // Adding load event listener that will fire only once
    iframe.addEventListener('load', handleLoad, { once: true });

    const handleError = () => {
      console.error('Error occurred while loading iframe content. Please check the source of the iframe.');
    };

    // Adding error listener
    iframe.addEventListener('error', handleError);

    // Cleanup error listener on component unmount
    return () => {
      iframe.removeEventListener('error', handleError);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      srcDoc={srcDoc}
      frameBorder="0"
      style={{ width: '100%', height: '100%', borderStyle: 'none' }}
    />
  );
};

export default Frame;
